import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';

// Public Pages
import Home from '@/pages/Home';
import AboutUs from '@/pages/AboutUs';
import Newsroom from '@/pages/Newsroom';
import PressReleaseDetail from '@/pages/PressReleaseDetail';
import Pricing from '@/pages/Pricing';
import SubmitPressRelease from '@/pages/SubmitPressRelease';
import Contact from '@/pages/Contact';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsConditions from '@/pages/TermsConditions';
import MediaDistribution from '@/pages/MediaDistribution';
import AnalyticsReports from '@/pages/AnalyticsReports';
import CookiePolicy from '@/pages/CookiePolicy';

// Admin Pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import CreatePressRelease from '@/pages/admin/CreatePressRelease';
import EditPressRelease from '@/pages/admin/EditPressRelease';

// Layout Components
import Layout from '@/components/Layout';
import AdminLayout from '@/components/AdminLayout';
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/newsroom" element={<Newsroom />} />
          <Route path="/newsroom/:slug" element={<PressReleaseDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/submit-press-release" element={<SubmitPressRelease />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/media-distribution" element={<MediaDistribution />} />
          <Route path="/analytics-reports" element={<AnalyticsReports />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/press-releases/new" element={<CreatePressRelease />} />
          <Route path="/admin/press-releases/edit/:id" element={<EditPressRelease />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;